<footer class="footer">
  <div class="container-fluid">
    <div class="footer-content">
      <div class="footer-left">
        
      </div>
      <div class="copyright">
        <span>© {{ currentYear }} Assetvio - {{ 'ABOUT.PLATFORM_NAME' | translate }}. {{ 'ABOUT.RIGHTS' | translate }}</span>
      </div>
      <div class="footer-right">
        
      </div>
    </div>
  </div>
</footer>